import React, { ChangeEvent, type FC, useCallback } from 'react';
import { useFormikContext, getIn } from 'formik';
import { styled } from '../../../styles';
import { Checkbox, CheckboxProps } from '../../Checkbox/Checkbox';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

export const AppFormCheckbox: FC<CheckboxProps> = (props) => {
  const context = useAppFormControlContext();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const name = 'name' in props ? props.name : context.name;
  const disabled = 'disabled' in props ? props.disabled : context.disabled;
  const value = 'checked' in props ? props.checked : name ? getIn(values, name) : undefined;
  const onChange = props.onChange;
  const handleOnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(e, !value);
      } else if (name) {
        setFieldTouched(name);
        setFieldValue(name, !value);
      }
    },
    [name, onChange, setFieldTouched, setFieldValue, value]
  );
  return (
    <StyledCheckbox
      {...props}
      disabled={disabled}
      checked={value}
      onChange={handleOnChange}
      dataTest={appFormDataTestFactory(props.dataTest ?? context.dataTest).input}
      slotProps={{
        checkbox: {
          id: (props.id ?? context.name) ? `${context.name}-input` : undefined
        }
      }}
    />
  );
};

const StyledCheckbox = styled(Checkbox)`
    margin-left: 0;
`;
